// AUTO-GENERATED - DO NOT EDIT MANUALLY
import ext_airtechpro_gsc_avif_1280 from "@/assets/opt/airtechpro-gsc-1280.avif.asset.json";
import ext_airtechpro_gsc_avif_640 from "@/assets/opt/airtechpro-gsc-640.avif.asset.json";
import ext_airtechpro_gsc_webp_1280 from "@/assets/opt/airtechpro-gsc-1280.webp.asset.json";
import ext_airtechpro_gsc_webp_640 from "@/assets/opt/airtechpro-gsc-640.webp.asset.json";
import ext_carage_semrush_avif_1280 from "@/assets/opt/carage-semrush-1280.avif.asset.json";
import ext_carage_semrush_avif_640 from "@/assets/opt/carage-semrush-640.avif.asset.json";
import ext_carage_semrush_webp_1280 from "@/assets/opt/carage-semrush-1280.webp.asset.json";
import ext_carage_semrush_webp_640 from "@/assets/opt/carage-semrush-640.webp.asset.json";
import ext_foreignaffairs_semrush_avif_1280 from "@/assets/opt/foreignaffairs-semrush-1280.avif.asset.json";
import ext_foreignaffairs_semrush_avif_640 from "@/assets/opt/foreignaffairs-semrush-640.avif.asset.json";
import ext_foreignaffairs_semrush_webp_1280 from "@/assets/opt/foreignaffairs-semrush-1280.webp.asset.json";
import ext_foreignaffairs_semrush_webp_640 from "@/assets/opt/foreignaffairs-semrush-640.webp.asset.json";
import ext_lynx_gsc_avif_1280 from "@/assets/opt/lynx-gsc-1280.avif.asset.json";
import ext_lynx_gsc_avif_640 from "@/assets/opt/lynx-gsc-640.avif.asset.json";
import ext_lynx_gsc_webp_1280 from "@/assets/opt/lynx-gsc-1280.webp.asset.json";
import ext_lynx_gsc_webp_640 from "@/assets/opt/lynx-gsc-640.webp.asset.json";
import ext_umair_avif_320 from "@/assets/opt/umair-320.avif.asset.json";
import ext_umair_avif_640 from "@/assets/opt/umair-640.avif.asset.json";
import ext_umair_webp_320 from "@/assets/opt/umair-320.webp.asset.json";
import ext_umair_webp_640 from "@/assets/opt/umair-640.webp.asset.json";
import ext_home_hero_v2_avif_640 from "@/assets/opt/home-hero-v2-640.avif.asset.json";
import ext_home_hero_v2_avif_1280 from "@/assets/opt/home-hero-v2-1280.avif.asset.json";
import ext_home_hero_v2_webp_640 from "@/assets/opt/home-hero-v2-640.webp.asset.json";
import ext_home_hero_v2_webp_1280 from "@/assets/opt/home-hero-v2-1280.webp.asset.json";

export type MediaSource = { url: string; w: number };
export type MediaSet = { avif: MediaSource[]; webp: MediaSource[]; width: number; height: number; };

export const EXTRA_MEDIA_VARIANTS: Record<string, MediaSet> = {
  "home-hero-v2": {
    avif: [
      { url: ext_home_hero_v2_avif_640.url, w: 640 },
      { url: ext_home_hero_v2_avif_1280.url, w: 1280 },
    ],
    webp: [
      { url: ext_home_hero_v2_webp_640.url, w: 640 },
      { url: ext_home_hero_v2_webp_1280.url, w: 1280 },
    ],
    width: 1280,
    height: 806,
  },
  "airtechpro-gsc": {
    avif: [
      { url: ext_airtechpro_gsc_avif_640.url, w: 640 },
      { url: ext_airtechpro_gsc_avif_1280.url, w: 1280 },
    ],
    webp: [
      { url: ext_airtechpro_gsc_webp_640.url, w: 640 },
      { url: ext_airtechpro_gsc_webp_1280.url, w: 1280 },
    ],
    width: 1280,
    height: 720,
  },
  "carage-semrush": {
    avif: [
      { url: ext_carage_semrush_avif_640.url, w: 640 },
      { url: ext_carage_semrush_avif_1280.url, w: 1280 },
    ],
    webp: [
      { url: ext_carage_semrush_webp_640.url, w: 640 },
      { url: ext_carage_semrush_webp_1280.url, w: 1280 },
    ],
    width: 1280,
    height: 720,
  },
  "foreignaffairs-semrush": {
    avif: [
      { url: ext_foreignaffairs_semrush_avif_640.url, w: 640 },
      { url: ext_foreignaffairs_semrush_avif_1280.url, w: 1280 },
    ],
    webp: [
      { url: ext_foreignaffairs_semrush_webp_640.url, w: 640 },
      { url: ext_foreignaffairs_semrush_webp_1280.url, w: 1280 },
    ],
    width: 1280,
    height: 720,
  },
  "lynx-gsc": {
    avif: [
      { url: ext_lynx_gsc_avif_640.url, w: 640 },
      { url: ext_lynx_gsc_avif_1280.url, w: 1280 },
    ],
    webp: [
      { url: ext_lynx_gsc_webp_640.url, w: 640 },
      { url: ext_lynx_gsc_webp_1280.url, w: 1280 },
    ],
    width: 1280,
    height: 720,
  },
  "umair": {
    avif: [
      { url: ext_umair_avif_320.url, w: 320 },
      { url: ext_umair_avif_640.url, w: 640 },
    ],
    webp: [
      { url: ext_umair_webp_320.url, w: 320 },
      { url: ext_umair_webp_640.url, w: 640 },
    ],
    width: 640,
    height: 640,
  },
};
